<template>
    <client-page>
        <about-introduction />
        <about-plant />
        <about-company />
    </client-page>
</template>

<script>
import ClientPage from "@/components/client/templates/client-page.vue";
import AboutIntroduction from "@/components/client/about/about-introduction.vue";
import AboutPlant from "@/components/client/about/about-plant.vue";
import AboutCompany from "@/components/client/about/about-company.vue";

export default {
    components: {
        ClientPage,
        AboutIntroduction,
        AboutPlant,
        AboutCompany,
    },
    data() {
        return {};
    },
};
</script>